module.exports = __webpack_public_path__ + "img/8.82e7342d.jpg";